import AcademicNode from './nodes/AcademicNode'
import MarkerNode from './nodes/MarkerNode'
import CategoryNode from './nodes/CategoryNode'
import LabelNode from './nodes/LabelNode'
import IconNode from './nodes/IconNode'
import RefNode from './nodes/RefNode'
import TaskNode from './nodes/TaskNode'
import ImageNode from './nodes/ImageNode'
import SuperCategoryNode from './nodes/SuperCategoryNode'
import SuperRefNode from './nodes/SuperRefNode'
import SuperLabelNode from './nodes/SuperLabelNode'

let academicTemplate = {
    /*settings : {
        maxHeight : 400,
        maxWidth : 500,
        minHeight : 90,
        minWidth : 120
    },*/
    id: 6,
    name: "Academic",
    component: AcademicNode,
    fields : [
        {
            label : "Files",
            name : "files",
            type : "files",
            defaultRender: false,
        },
        {
            label : "Title",
            name : "title",
            type : "textarea",
            hasRender: true,
            defaultRender: true,
            hasFontSize: true,
            defaultFontSize: 'medium'
        },
        {
            label : "Authors",
            name : "authors",
            type : "array",
            hasRender: true,
            defaultRender: true,
            hasFontSize: true,
            defaultFontSize: 'small'
        },
        {
            label : "Publication",
            name : "journal",
            type : "text",
            hasRender: true,
            defaultRender: false,
            hasFontSize: true,
            defaultFontSize: 'small'
        },
        {
            label : "Date",
            name : "year",
            type : "text",
            hasRender: true,
            defaultRender: true,
            hasFontSize: true,
            defaultFontSize: 'small'
        },
        {
            label : "Volume",
            name : "volume",
            type : "text",
            hasRender: false,
            defaultRender: false,
            hasFontSize: false,
            defaultFontSize: 'small'
        },
        {
            label : "Issue",
            name : "issue",
            type : "text",
            hasRender: false,
            defaultRender: false,
            hasFontSize: false,
            defaultFontSize: 'small'
        },
        {
            label : "Abstract",
            name : "abstract",
            type : "textarea",
            hasRender: false,
            defaultRender: false,
            hasFontSize: false,
            defaultFontSize: 'small'
        },
        {
            label : "Keywords",
            name : "keywords",
            type : "array",
            hasRender: true,
            defaultRender: false,
            hasFontSize: true,
            defaultFontSize: 'small'
        },
        {
            label : "URL",
            name : "url",
            type : "url",
            defaultRender: false,
        },
        {
            label : "Tags",
            name : "tags",
            type : "array",
            hasRender: true,
            defaultRender: true,
            hasFontSize: true,
            defaultFontSize: 'small'
        },
        {
            label : "ArXiv ID",
            name : "arxivId",
            type : "oneid",
            hasRender: false,
            defaultRender: false,
            hasFontSize: false,
            defaultFontSize: 'small'
        },
        {
            label : "DOI",
            name : "doi",
            type : "oneid",
            hasRender: false,
            defaultRender: false,
            hasFontSize: false,
            defaultFontSize: 'small'
        },
        {
            label : "ISBN",
            name : "isbn",
            type : "oneid",
            hasRender: false,
            defaultRender: false,
            hasFontSize: false,
            defaultFontSize: 'small'
        },
        {
            label : "ISSN",
            name : "issn",
            type : "oneid",
            hasRender: false,
            defaultRender: false,
            hasFontSize: false,
            defaultFontSize: 'small'
        },
        {
            label : "PMID",
            name : "pmid",
            type : "oneid",
            hasRender: false,
            defaultRender: false,
            hasFontSize: false,
            defaultFontSize: 'small'
        },
        {
            label : "_______IDs",
            name : "idsgroup",
            type : "idsgroup",
            hasRender: false,
            defaultRender: false,
            hasFontSize: false,
            defaultFontSize: 'small'
        },
        // {
        //     label : "Citations",
        //     name : "citations",
        //     type : "array",
        //     hasRender: false,
        //     hasFontSize: false
        // },
        {
            label: 'Node color',
            name: 'color',
            type: 'color'
        },
        {
            label : "Referenced node",
            name : "ref",
            type : "ref",
            hasRender: false,
            hasFontSize: false,
        }
    ]
}

const markerTemplate = {
    id: 0,
    name: "Marker",
    component: MarkerNode,
    fields: [
        {
            label : "Title",
            name : "title",
            type : "text"
        },
        {
            label: 'Background color',
            name: 'color',
            type: 'color'
        },
        {
            label : "Referenced node",
            name : "ref",
            type : "ref",
            hasRender: false,
            hasFontSize: false,
        }
    ]
}

const categoryTemplate = {
    id: 1,
    name: "Category",
    component: CategoryNode,
    fields: [
        {
            label : "Title",
            name : "title",
            type : "text"
        },
        {
            label : "Description",
            name : "description",
            type : "text"
        },
        {
            label: 'Node color',
            name: 'color',
            type: 'color'
        },
        {
            label : "Referenced node",
            name : "ref",
            type : "ref",
            hasRender: false,
            hasFontSize: false,
        }
    ]
}

const labelTemplate = {
    id: 2,
    name: "Label",
    component: LabelNode,
    fields: [
        {
            label : "Title",
            name : "title",
            type : "text",
            hasRender: false,
            defaultRender: true,
            hasFontSize: false,
            defaultFontSize: 'large'
        },
        {
            label : "Description",
            name : "description",
            type : "textarea",
            hasRender: false,
            defaultRender: true,
            hasFontSize: false,
            defaultFontSize: 'small'
        },
        {
            label : "Files",
            name : "files",
            type : "files",
            defaultRender: false,
        },
        {
            label: 'Node color',
            name: 'color',
            type: 'color'
        },
        {
            label : "Referenced node",
            name : "ref",
            type : "ref",
            hasRender: false,
            hasFontSize: false,
        }
    ]
}

const iconTemplate = {
    id: 3,
    name: "Icon",
    component: IconNode,
    fields: [
        {
            label : "Title",
            name : "title",
            type : "text",
            hasRender: true,
            defaultRender: true
        },
        {
            label : "Icon path",
            name : "path",
            type : "text"
        },
        {
            label: 'Node color',
            name: 'color',
            type: 'color'
        },
        {
            label : "Referenced node",
            name : "ref",
            type : "ref",
            hasRender: false,
            hasFontSize: false,
        }
    ]
}

const linkTemplate = {
    id: 4,
    name: "Link",
    component: null,
    fields: [
        {
            label : "Link type",
            name : "w1x",
            type : "linkweight"
        },
        {
            label : "Link type",
            name : "w1y",
            type : "linkweight"
        },
        {
            label : "Link type",
            name : "w2x",
            type : "linkweight"
        },
        {
            label : "Link type",
            name : "w2y",
            type : "linkweight"
        },
        {
            label : "Link shape",
            name : "linkshape",
            type : "linkshape"
        },
        {
            label : "Link width",
            name : "width",
            type : "linkwidth"
        },
        {
            label: 'Link color',
            name: 'color',
            type: 'color'
        },
        {
            label : "Link symbol",
            name : "linksymbol",
            type : "linksymbol"
        },
    ]
}

const ndbkRefTemplate = {
    id: 5,
    name: "Ref",
    component: RefNode,
    fields: [
        {
            label : "Title",
            name : "title",
            type : "text",
            hasRender: true,
            defaultRender: true
        },
        {
            label : "Referenced node",
            name : "ref",
            type : "ref",
            hasRender: false,
            hasFontSize: false,
        }
    ]
}

const taskTemplate = {
    id: 7,
    name: "Task",
    component: TaskNode,
    fields: [
        {
            label: "Likes",
            name: "likes",
            type: "likes",
            default: {
                val: 0,
            }
        },
        {
            label: "Title",
            name: "title",
            type: "text",
            default: {
                val: '',
            }
        },
        {
            label: "Description",
            name: "description",
            type: "textarea",
            default: {
                val: '',
            }
        },
        {
            label: "Tags",
            name: "tags",
            type: "array",
            default: {
                val: [],
            }
        },
        {
            label: "Assignees",
            name: "assignees",
            type: "array",
            default: {
                val: [],
            }
        },
        {
            label: "Attachments",
            name: "files",
            type: "files",
            default: {
                val: [],
            }
        },
    ]
}

const imageTemplate = {
    id: 8,
    name: "Image",
    component: ImageNode,
    fields: [
        {
            label: "Title",
            name: "title",
            type: "text",
            hasRender: true,
            hasFontSize: false,
        },
        {
            label: "Image",
            name: "image",
            type: "text",
            hasRender: false,
            hasFontSize: false,
        }
    ]
}

let superCategory = {
    id: 9,
    name: "superCategory",
    component: SuperCategoryNode,
    fields : [
        {
            label : "Files",
            name : "files",
            type : "files",
            default: {
                val: [],
            }
        },
        {
            label : "Title",
            name : "title",
            type : "textarea",
            hasRender: true,
            default: {
                val: 'New category',
                render: {
                    fontSize: '18px',
                    fill: '#222',
                    fontStyle: 'normal',
                    fontWeight: 'bold',
                }
            }
        },
        {
            label : "URL",
            name : "url",
            type : "url",
            default: {
                val: [],
            }
        },
        {
            label : "Tags",
            name : "tags",
            type : "array",
            default: {
                val: [],
            }
        },
        {
            label: "Image",
            name: "image",
            type: "img",
            default: {
                val: '',
            }
        },
        {
            label: 'Background color',
            name: 'color',
            type: 'color',
            default: {
                val: '#fff',
            }
        },
        {
            label: 'Border color',
            name: 'bdcolor',
            type: 'color',
            default: {
                val: 'transparent',
            }
        },
        {
            label: 'Layout',
            name: 'layout',
            type: 'layout',
            default: {
                val: 9,
            }
        },
        {
            label : "Referenced node",
            name : "ref",
            type : "ref",
            default: {
                val: '',
            }
        },
        {
            label : "Render settings",
            name : "_render",
            type : "_render",
            default: {
                val: {},
            }
        },
        {
            label : "Description",
            name : "description",
            type : "textarea",
            default: {
                val: '',
            }
        },
    ]
}

let superRef = {
    /*settings : {
        maxHeight : 400,
        maxWidth : 500,
        minHeight : 90,
        minWidth : 120
    },*/
    id: 10,
    name: "SuperRef",
    component: SuperRefNode,
    fields : [
        {
            label : "Files",
            name : "files",
            type : "files",
            default: {
                val: [],
            }
        },
        {
            label : "Title",
            name : "title",
            type : "textarea",
            hasRender: true,
            default: {
                val: 'New node',
                render: {
                    display: true,
                    fontSize: '16px',
                    fill: '#222',
                    fontStyle: 'normal',
                    fontWeight: 'bold',
                    textAlign: 'left',
                    overflow: true,
                    // backgroundColor: 'transparent',
                }
            }
        },
        {
            label : "Authors",
            name : "authors",
            type : "array",
            hasRender: true,
            default: {
                val: [],
                render: {
                    display: true,
                    fontSize: '12px',
                    fill: '#666',
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    textAlign: 'left',
                    overflow: false,
                }
            }
        },
        {
            label : "Publication",
            name : "journal",
            type : "text",
            hasRender: true,
            default: {
                val: '',
                render: {
                    display: false,
                    fontSize: '12px',
                    fill: '#666',
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    textAlign: 'left',
                    overflow: false,
                }
            }
        },
        {
            label : "Volume",
            name : "volume",
            type : "text",
            default: {
                val: '',
            }
        },
        {
            label : "Issue",
            name : "issue",
            type : "text",
            default: {
                val: '',
            }
        },
        {
            label : "Date",
            name : "year",
            type : "text",
            hasRender: true,
            default: {
                val: '',
                render: {
                    display: false,
                    fontSize: '12px',
                    fill: '#666',
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    textAlign: 'left',
                }
            }
        },
        {
            label : "Abstract",
            name : "abstract",
            type : "textarea",
            hasRender: true,
            default: {
                val: '',
                render: {
                    display: false,
                    fontSize: '12px',
                    fill: '#666',
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    textAlign: 'left',
                    overflow: true,
                }
            }
        },
        {
            label : "Keywords",
            name : "keywords",
            type : "array",
            hasRender: true,
            default: {
                val: [],
                render: {
                    display: false,
                    fontSize: '12px',
                    fill: '#666',
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    textAlign: 'left',
                    overflow: false,
                }
            }
        },
        {
            label : "URL",
            name : "url",
            type : "url",
            default: {
                val: [],
            }
        },
        {
            label : "Tags",
            name : "tags",
            type : "array",
            hasRender: true,
            default: {
                val: [],
                render: {
                    display: true,
                    fontSize: '12px',
                    fill: '#666',
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    textAlign: 'left',
                    overflow: false,
                }
            }
        },
        {
            label : "ArXiv ID",
            name : "arxivId",
            type : "oneid",
            default: {
                val: '',
            }
        },
        {
            label : "DOI",
            name : "doi",
            type : "oneid",
            default: {
                val: '',
            }
        },
        {
            label : "ISBN",
            name : "isbn",
            type : "oneid",
            default: {
                val: '',
            }
        },
        {
            label : "ISSN",
            name : "issn",
            type : "oneid",
            default: {
                val: '',
            }
        },
        {
            label : "PMID",
            name : "pmid",
            type : "oneid",
            default: {
                val: '',
            }
        },
        {
            label : "_______IDs",
            name : "idsgroup",
            type : "idsgroup",
            default: {
                val: {},
            }
        },
        // {
        //     label : "Citations",
        //     name : "citations",
        //     type : "array",
        //     hasRender: false,
        //     hasFontSize: false
        // },
        {
            label: "Image",
            name: "image",
            type: "img",
            default: {
                val: '',
            }
        },
        {
            label: 'Background color',
            name: 'color',
            type: 'color',
            default: {
                val: '#fff',
            }
        },
        {
            label: 'Border color',
            name: 'bdcolor',
            type: 'color',
            default: {
                val: '#E1E8ED',
            }
        },
        {
            label: 'Layout',
            name: 'layout',
            type: 'layout',
            default: {
                val: 10,
            }
        },
        {
            label : "Referenced node",
            name : "ref",
            type : "ref",
            default: {
                val: '',
            }
        },
        {
            label : "Render settings",
            name : "_render",
            type : "_render",
            default: {
                val: {},
            }
        },
        {
            label : "Description",
            name : "description",
            type : "textarea",
            hasRender: true,
            default: {
                val: '',
                render: {
                    display: false,
                    fontSize: '12px',
                    fill: '#666',
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    textAlign: 'left',
                    overflow: true,
                }
            }
        },
    ]
}

let superLabel = {
    id: 11,
    name: "superLabel",
    component: SuperLabelNode,
    fields : [
        {
            label : "Files",
            name : "files",
            type : "files",
            default: {
                val: [],
            }
        },
        {
            label : "Title",
            name : "title",
            type : "textarea",
            hasRender: true,
            default: {
                val: 'New category',
                render: {
                    fontSize: '18px',
                    fill: '#222',
                    fontStyle: 'normal',
                    fontWeight: 'bold',
                }
            }
        },
        {
            label : "URL",
            name : "url",
            type : "url",
            default: {
                val: [],
            }
        },
        {
            label : "Tags",
            name : "tags",
            type : "array",
            default: {
                val: [],
            }
        },
        // {
        //     label: "Image",
        //     name: "image",
        //     type: "img",
        //     default: {
        //         val: '',
        //     }
        // },
        {
            label: 'Background color',
            name: 'color',
            type: 'color',
            default: {
                val: '#fff',
            }
        },
        {
            label: 'Border color',
            name: 'bdcolor',
            type: 'color',
            default: {
                val: 'transparent',
            }
        },
        {
            label: 'Layout',
            name: 'layout',
            type: 'layout',
            default: {
                val: 11,
            }
        },
        {
            label : "Referenced node",
            name : "ref",
            type : "ref",
            default: {
                val: '',
            }
        },
        {
            label : "Render settings",
            name : "_render",
            type : "_render",
            default: {
                val: {},
            }
        },
        {
            label : "Description",
            name : "description",
            type : "textarea",
            hasRender: true,
            default: {
                val: '',
                render: {
                    fontSize: '12px',
                    fill: '#666',
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                }
            }
        },
    ]
}

let superBasicTemplate = {
    id: 12,
    name: "superBasicTemplate",
    component: SuperRefNode,
    fields : [
        {
            label : "Files",
            name : "files",
            type : "files",
            default: {
                val: [],
            }
        },
        {
            label : "Title",
            name : "title",
            type : "textarea",
            hasRender: true,
            default: {
                val: 'New node',
                render: {
                    display: true,
                    fontSize: '18px',
                    fill: '#222',
                    fontStyle: 'normal',
                    fontWeight: 'bold',
                    textAlign: 'left',
                    overflow: true,
                }
            }
        },
        {
            label : "URL",
            name : "url",
            type : "url",
            default: {
                val: [],
            }
        },
        {
            label : "Tags",
            name : "tags",
            type : "array",
            hasRender: true,
            default: {
                val: [],
                render: {
                    display: true,
                    fontSize: '12px',
                    fill: '#666',
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    textAlign: 'left',
                    overflow: false,
                }
            }
        },
        {
            label: "Image",
            name: "image",
            type: "img",
            default: {
                val: '',
            }
        },
        {
            label: 'Background color',
            name: 'color',
            type: 'color',
            default: {
                val: '#fff',
            }
        },
        {
            label: 'Border color',
            name: 'bdcolor',
            type: 'color',
            default: {
                val: '#E1E8ED',
            }
        },
        {
            label: 'Layout',
            name: 'layout',
            type: 'layout',
            default: {
                val: 12,
            }
        },
        {
            label : "Referenced node",
            name : "ref",
            type : "ref",
            default: {
                val: '',
            }
        },
        {
            label : "Render settings",
            name : "_render",
            type : "_render",
            default: {
                val: {},
            }
        },
        {
            label : "Description",
            name : "description",
            type : "textarea",
            hasRender: true,
            default: {
                val: '',
                render: {
                    display: true,
                    fontSize: '12px',
                    fill: '#666',
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    textAlign: 'left',
                    overflow: true,
                }
            }
        },
    ]
}

export const TemplatesLib = {
    "0": markerTemplate,
    "1": categoryTemplate,
    "2": labelTemplate,
    "3": iconTemplate,
    "4": linkTemplate,
    "5": ndbkRefTemplate,
    "6": academicTemplate,
    "7": taskTemplate,
    "8": imageTemplate,
    "9": superCategory,
    "10": superRef,
    "11": superBasicTemplate, //superLabel,
    "12": superBasicTemplate,
}


// WEBPACK FOOTER //
// ./src/components/TemplatesLib.js